import * as $ from 'jquery';
import 'slick-carousel';


const slickCarousel = () => {
	// newListings
	$(function () {
		let $items = $('.newListingsCarousel__itemsInner');

		//@ts-ignore
		$items.slick({
			autoplay: true,
			autoplaySpeed: 3000,
			nextArrow: '<button type="button" class="slick-next"><span>Next</span></button>',
			prevArrow: '<button type="button" class="slick-prev"><span>Prev</span></button>',
			mobileFirst: false,
			variableWidth: false,
			slidesToShow: 3,
			responsive: [
				{breakpoint: 1024, settings: {slidesToShow: 2}},
				{breakpoint: 640, settings: {slidesToShow: 1}}
			]
		});
	});

	// Closing Carousels
	$(function () {
		let $items = $('.skyviewClosingsCarousel__itemsInner, .recentClosingsCarousel__itemsInner');

		//@ts-ignore
		$items.slick({
			autoplay: true,
			autoplaySpeed: 3000,
			nextArrow: '<button type="button" class="slick-next"><span>Next</span></button>',
			prevArrow: '<button type="button" class="slick-prev"><span>Prev</span></button>',
			mobileFirst: true,
			variableWidth: true
		});
	});
};

export default slickCarousel;
